<template>
  <div class="xinTu">
    <menuBox :step="1"></menuBox>
    <div class="contentBox">
      <div class="xinTu-content">
        <div class="xinTu-box">
          <p class="bt">Tin tưởng vào truyền thống và cầm cố một tương lai mới</p>
          <div class="btn" @click="step">tìm hiểu thêm</div>
        </div>
      </div>
      <div class="easiest-box">
        <div class="easiestBt">Xu hướng phát triển ngành cầm đồ</div>
        <div class="easiestTitle">Ngành cầm đồ đang phát triển nhanh chóng cùng với quá trình toàn cầu hóa kinh tế và tiến
          bộ công nghệ. Dịch vụ cầm đồ truyền thống đang phát triển theo hướng kỹ thuật số và thuận tiện hơn, cung cấp
          dịch vụ thẩm định và cho vay thông qua nền tảng trực tuyến, nâng cao đáng kể hiệu quả và khả năng tiếp cận. Đồng
          thời, nhu cầu ngày càng tăng về tính minh bạch và tuân thủ đang thúc đẩy ngành hướng tới tiêu chuẩn hóa và
          chuyên nghiệp hóa cao hơn. Ngoài ra, khi nhu cầu của người tiêu dùng về các giải pháp tài chính nhanh chóng,
          linh hoạt tăng lên, ngành cầm đồ đang trở thành một phần quan trọng trong công việc quản lý tài chính hàng ngày
          của nhiều người.</div>
        <div class="mission-box">
          <img src="../assets/Illustration.png" alt="">
          <img src="../assets/Illustration1.png" alt="">
        </div>
      </div>
      <div class="discount">
        <div class="title">
          Đôi nét về nghề cầm đồ
        </div>
        <div class="text">Tìm hiểu thêm về sự phát triển của công ty</div>
        <div class="btn">
          <span @click="step" style="cursor: pointer;">tìm hiểu thêm</span>
        </div>
      </div>
      <div class="projects">
        <div class="title">dự án</div>
        <div class="linebox">
          <div class="item">
            <img src="../assets/projects1.png" alt="">
            <p>Dịch vụ cầm đồ có giá trị</p>
          </div>
          <div class="item">
            <img src="../assets/projects2.png" alt="">
            <p>Giải pháp cho vay ngắn hạn</p>
          </div>
        </div>
        <div class="linebox">
          <div class="item">
            <img src="../assets/projects3.png" alt="">
            <p>Đánh giá tài sản cá nhân</p>
          </div>
          <div class="item">
            <img src="../assets/projects4.png" alt="">
            <p>Dịch vụ chuyển đổi tiền mặt nhanh chóng</p>
          </div>
        </div>
      </div>
      <footerBox></footerBox>
    </div>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "home",
  components: {
    menuBox,
    footerBox
  },
  data() {
    return {
      type: 1,
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "categories" });
    },
  },
};
</script>

<style lang="less" scoped>
.contentBox {
  flex: 1;
  overflow: hidden;
}

.xinTu {
  display: flex;
}

.xinTu-content {
  width: 100%;
  background-image: url(../assets/home.png);
  height: 700px;
  background-size: 100% 100%;
  padding: 222px 72px 0 72px;
  overflow: hidden;
  box-sizing: border-box;

  .xinTu-box {
    .bt {
      max-width: 800px;
      margin-bottom: 27px;
      font-size: 72px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 101px;
    }

    .btn {
      display: table;
      cursor: pointer;
      padding: 15px 26px;
      font-size: 16px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #FFFFFF;
      background: #C9292E;
      border-radius: 24px;
    }
  }
}

.easiest-box {
  margin: 100px 72px;

  .easiestBt {
    margin-bottom: 24px;
    font-size: 40px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 56px;
  }

  .easiestTitle {
    font-size: 20px;
    font-family: ArialMT;
    color: #999999;
    line-height: 32px;
  }

  .mission-box {
    margin-top: 74px;
    display: flex;

    img {
      margin-right: 56px;
      width: 621px;
      height: 361px;
    }

    img:nth-child(2) {
      margin-right: 0;
    }
  }
}

.discount {
  width: 100%;
  background-image: url(../assets/discount.png);
  height: 480px;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    margin-bottom: 5px;
    font-size: 48px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #C9292E;
    line-height: 68px;
  }

  .text {
    margin-bottom: 24px;
    font-size: 20px;
    font-family: ArialMT;
    color: #FFFFFF;
  }

  .btn {
    span {
      display: table;
      padding: 16px 27px;
      background: #DBA35C;
      border-radius: 24px;
      font-size: 16px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #333333;
    }
  }
}

.projects {
  padding: 100px 72px 0;

  .title {
    margin-bottom: 40px;
    font-size: 40px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
  }

  .linebox {
    display: flex;

    .item {
      position: relative;
      margin: 0 56px 56px 0;

      img {
        width: 620px;
        height: 425px;
      }

      p {
        position: absolute;
        bottom: 40px;
        left: 40px;
        font-size: 32px;
        font-family: Arial, Arial;
        font-weight: 900;
        color: #FFFFFF;
      }
    }

    .itme:nth-child(2) {
      margin-right: 0;
    }
  }
}</style>
